import * as React from "react";
import { SubAccountType } from "../../../../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { ClientDetails } from "../../../../../../../Wrap/Models/Models/Processes/Quote/ClientDetails";
import { CheckboxGroup } from "../../../../../../Shared/CheckboxGroup/CheckboxGroup";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../Shared/Process/Process/ProcessComponent";
import { SectionHeader } from "../../../NewBusinessWizard/Components/SharedComponents";
import { isTaxRelifAvailable } from "../../../NewQuoteWizard/Components/Shared/Utils";
import { EmployerInfoIcon, PaymentPayerToPaymentTypeMap, PaymentType, processTypeEnum } from "../../Resource/Contents";
import { PaymentType as PaymentFrequencyType} from "../../../../../../../Wrap/Constants/Enums/Apply/PaymentType";
import { RegularPaymentDetail } from "./RegularPaymentDetail";
import { BankAccountInstruction } from "../../../../../../../Wrap/Models/Domains/Instructions/BankAccountInstruction";
import { RegularDepositMethod } from "../../../../../../../Wrap/Constants/Enums/Domain/RegularDepositMethod";
import { WizardLinter, EWizardLinterStatus } from "../../../../../../Shared/Process/Process/WizardLinter";
import { EWizardLinterHelper } from "../../../NewBusinessWizard/Resource/EWizardLinterHelper";
import { BankAccount } from "../../../../../../../Wrap/Models/Domains/BankAccount/BankAccount";
import { Alert } from "../../../../../../Shared/Components/Alert";
import { AlertType } from "../../../../../../Shared/Entities/Constants/AlertConstants";
import { DateHelper } from "../../../../../../../react-core/Helpers/DateHelper";
import { JsonDateParser } from "../../../../../../../react-core/Utils/JsonDateParser";
import { getQueryParameters } from "../../../../../../Shared/Wizards/Entities/QueryParametersHelper";
import { User } from "../../../../../../../Wrap/Models/Models/User/User";
import { GENERIC_RESTRICTIONS_MESSAGE } from "../../../../../../Shared/Common/UserMessages";
import { UserStore } from "../../../../../Stroes/Variable";
import { RestrictionStore } from "../../Restrictions/Variable";
import { CommonHelper } from "../../../../../../../react-core/Helpers/CommonHelper";
import { RestrictionHelper } from "../../../../../../Shared/Common/RestrictionHelper";
import { RestrictionAction } from "../../Restrictions/RestrictionAction";
import { SIPPPaymentInCheckboxGroup } from "../SIPPPaymentInCheckboxGroup";
import { PendingPaymentInModel } from "../../../../../../../Wrap/Models/Models/Payments/Deposits/PendingPaymentInModel";
import { Position } from "../../../../../../../react-core/Enums/Position";

interface IRegularPaymentProps extends IProcessComponentProps {
    clientInfo: ClientDetails;
    checkBoxOption: Array<PaymentType>;
    subAccountType: SubAccountType;
    hasIndexation?: boolean;
    hasContinue?: boolean;
    hasPaymentMethod?: boolean;
    bankAccounts?: BankAccount[];
    bankAccountInstructions?: BankAccountInstruction[];
    processType: processTypeEnum;
    pendingPaymentsIn?: Array<PendingPaymentInModel>;
    isEdit?: boolean;
    HasExistingSIPP?: boolean;
    onSaveNewBankAccountInstruction?: (BankAccountInstruction: BankAccountInstruction) => void;
    onRemoveBankAccountInstruction?: (BankAccountInstruction: BankAccountInstruction) => void;
    inUseBankAccountInstruction?: string[];
    autoLineCompleted?: boolean;
    IsDisqualifyingPensionCredits?: boolean;
}

interface IRegularPaymentState {
    userInfo: User;
}

export class RegularPayment extends ProcessComponent<IRegularPaymentProps, IRegularPaymentState> {
    public static defaultProps = {
        autoLineCompleted: true,
    };
    constructor(props: any) {
        super(props);
        this.state = {
            userInfo: UserStore.getUserInfo(),
        };
    }
    private getKey = (key: PaymentType) => {
        switch (key) {
            case PaymentType.Client:
                return "ClientRegularPayment";
            case PaymentType.ThirdParty:
                return "ThirdPartyRegularPayment";
            case PaymentType.Employer:
                return "EmployerRegularPayment";
            case PaymentType.EmployerSalaryDeduction:
                return "EmployerSalaryDeductionRegularPayment";
        }
    };

    componentDidMount() {
        super.componentDidMount();
        if (RestrictionStore.getData() == null) {
            if (!CommonHelper.isNullOrEmpty(getQueryParameters()["subaccounthierarchyid"])) {
                RestrictionAction.getRestrictionByHierarchyId(getQueryParameters()["subaccounthierarchyid"]);
            } else if (!CommonHelper.isNullOrEmpty(getQueryParameters()["hierarchyid"])) {
                RestrictionAction.getRestrictionByHierarchyId(getQueryParameters()["hierarchyid"]);
            }
        }
    }

    private getOptions = () => {
        const { checkBoxOption, data, onChange, processType, isEdit, pendingPaymentsIn } = this.props;
        let isRestrictionActive = false;

        if (RestrictionHelper.shouldHandleRestriction(processType)) {
            isRestrictionActive = RestrictionStore.depositDisabled();
        }

        const isNone = checkBoxOption.map((type) => data[this.getKey(type)] == null).every((ele) => ele == true);
        const empty = {};
        checkBoxOption.forEach((type) => {
            empty[this.getKey(type)] = null;
        });
        const options = [
            {
                label: "None",
                value: isNone,
                disabled: isRestrictionActive || this.props.isEdit || !this.props.autoLineCompleted || processType === processTypeEnum.RegularPayment || this.props.IsDisqualifyingPensionCredits,
                onChange: (v) => onChange(empty),
                tooltip: null,
                tooltipPosition: null
            },
        ];

        checkBoxOption.forEach((type) => {
            let disable: boolean = this.DisableRegularPaymentsInForPaymentType(type, pendingPaymentsIn);
            let disableMessage: string = "Maximum amount of three payments\n for " + type + " payment type is exceeded";

            options.push({
                label: type,
                value: data[this.getKey(type)] != null,
                disabled:
                    ((this.props.processType == processTypeEnum.NewBusinessExistingClient ||
                        this.props.processType == processTypeEnum.NewQuoteExistingClient) &&
                        this.props.HasExistingSIPP == true) ||
                    isRestrictionActive ||
                    (data[this.getKey(type)] && data[this.getKey(type)]?.RegularBuyId) ||
                    !this.props.autoLineCompleted ||
                    disable ||
                    this.props.IsDisqualifyingPensionCredits,
                onChange: async (v) => {
                    if (processType == processTypeEnum.Quote || processType == processTypeEnum.WhatIfTool) {
                        onChange({
                            [this.getKey(type)]: v
                                ? {
                                      TaxRelief: await isTaxRelifAvailable(this.props.clientInfo?.DateOfBirth, new Date()) && (this.props.subAccountType === SubAccountType.Npr || this.props.subAccountType === SubAccountType.JuniorSipp),
                                      RegularPaymentMethod: RegularDepositMethod.NotSpecified,
                                      RegularBuyId: null,
                                  }
                                : null,
                        });
                    } else {
                        onChange({
                            [this.getKey(type)]: v
                                ? {
                                      TaxRelief: await isTaxRelifAvailable(this.props.clientInfo?.DateOfBirth, new Date()) && (this.props.subAccountType === SubAccountType.Npr || this.props.subAccountType === SubAccountType.JuniorSipp),
                                      RegularPaymentMethod: RegularDepositMethod.DirectDebit,
                                      RegularBuyId: null,
                                  }
                                : null,
                        });
                    }
                },
                tooltip: disable ? disableMessage : null,
                tooltipPosition: disable ? Position.Right : null
            });
        });

        return options;
    };

    private DisableRegularPaymentsInForPaymentType(paymentType: PaymentType, pendingPaymentsIn?: Array<PendingPaymentInModel>): boolean {
        if(!pendingPaymentsIn || pendingPaymentsIn.length == 0){
            return false;
        }
        return pendingPaymentsIn.filter( (payment: PendingPaymentInModel) => {
            return (
                payment.Type === PaymentFrequencyType.Regular &&
                payment.Payer === PaymentPayerToPaymentTypeMap[paymentType]
            )
        }).length >= 3
    }

    private getProps = (key) => {
        const {
            data,
            onChange,
            subAccountType,
            clientInfo,
            bankAccounts,
            bankAccountInstructions,
            hasPaymentMethod,
            processType,
            isReview,
            onSaveNewBankAccountInstruction,
            onRemoveBankAccountInstruction,
            inUseBankAccountInstruction,
        } = this.props;
        return {
            clientInfo: clientInfo,
            label: key,
            type: key,
            data: data[this.getKey(key)],
            onChange: (changes) => this.onDataChange(onChange, changes, data, this.getKey(key)),
            onRef: (ref) => this.appendChild(ref),
            subAccountType: subAccountType,
            bankAccounts: bankAccounts,
            bankAccountInstructions: bankAccountInstructions,
            hasPaymentMethod: hasPaymentMethod,
            processType: processType,
            isReview: isReview,
            onSaveNewBankAccountInstruction: onSaveNewBankAccountInstruction,
            showErrorMsgPopUp: this.props.showErrorMsgPopUp,
            onRemoveBankAccountInstruction: onRemoveBankAccountInstruction,
            inUseBankAccountInstruction: inUseBankAccountInstruction,
        };
    };

    public getNextPaymentDate = (firstPaymentDate, nextPaymentDate) => {
        const first = JsonDateParser.toDate(firstPaymentDate);
        const next = JsonDateParser.toDate(nextPaymentDate);
        const useDate = first && first > new Date() ? first : next;
        return useDate ? DateHelper.getDayDifference(JsonDateParser.toDate(useDate), new Date()) : -1;
    };

    public render(): JSX.Element {
        const { data, subAccountType, isEdit, processType, IsDisqualifyingPensionCredits } = this.props;
        if (IsDisqualifyingPensionCredits) {
            data.ClientRegularPayment = null;
            data.ThirdPartyRegularPayment = null;
            data.EmployerSalaryDeductionRegularPayment = null;
            data.EmployerRegularPayment = null;
        }
        let isRestrictionActive = false;
        if (RestrictionHelper.shouldHandleRestriction(processType)) {
            isRestrictionActive = RestrictionStore.depositDisabled();
        }
        const clientNextPaymentdate = this.getNextPaymentDate(
            data?.ClientRegularPayment?.FirstCollectionDate,
            data?.ClientRegularPayment?.NextPaymentDate
        );

        const thirdPartyNextPaymentdate = this.getNextPaymentDate(
            data?.ThirdPartyRegularPayment?.FirstCollectionDate,
            data?.ThirdPartyRegularPayment?.NextPaymentDate
        );
        const employerNextPaymentdate = this.getNextPaymentDate(
            data?.EmployerRegularPayment?.FirstCollectionDate,
            data?.EmployerRegularPayment?.NextPaymentDate
        );
        const employerSalaryDeductionNextPaymentdate = this.getNextPaymentDate(
            data?.EmployerSalaryDeductionRegularPayment?.FirstCollectionDate,
            data?.EmployerSalaryDeductionRegularPayment?.NextPaymentDate
        );

        let restrictedMessage = "An account with suspended or restricted activities cannot receive regular payment";

        if (this.state.userInfo != null && this.state.userInfo.IsAdviser) {
            restrictedMessage = GENERIC_RESTRICTIONS_MESSAGE;
        }

        var options = this.getOptions()
        var hasEmployerOption = options.find(x=>x.label == "Employer")

        const batchId = getQueryParameters()["batchid"];
        if(batchId && processType !== processTypeEnum.WhatIfTool) {
            options.forEach((option, index) => {
                options[index].disabled = true;
            });
        }

        return (
            <WizardLinter
                status={EWizardLinterStatus.PleaseCheck}
                enabled={EWizardLinterHelper.shouldDisplay(subAccountType)}
            >
                {!hasEmployerOption && SectionHeader(
                    "Regular payment",
                    isEdit ? "More than one payer type can be selected in this instruction." : ""
                )}
                {hasEmployerOption && SectionHeader(
                    "Regular payment",
                    isEdit ? "More than one payer type can be selected in this instruction.\n" + EmployerInfoIcon : EmployerInfoIcon
                )}
                {isRestrictionActive && <Alert alertType={AlertType.Error} message={restrictedMessage} />}
                {([processTypeEnum.NewBusiness, processTypeEnum.NewBusinessExistingClient,
                    processTypeEnum.Quote, processTypeEnum.RegularPayment,
                    processTypeEnum.WhatIfTool]
                        .includes(this.props.processType)) &&
                    (this.props.subAccountType == SubAccountType.Npr || this.props.subAccountType == SubAccountType.JuniorSipp) ?
                    (<SIPPPaymentInCheckboxGroup type="150" wrapCss="square-checkbox" options={options} />) :
                    <CheckboxGroup type="150" wrapCss="square-checkbox" options={this.getOptions()} />}
                {clientNextPaymentdate != -1 &&
                    clientNextPaymentdate <= 10 &&
                    this.props.processType === processTypeEnum.RegularPayment && (
                        <Alert
                            alertType={AlertType.Warning}
                            message={`Please note the next collection date is within 10 days so cannot be edited.`}
                        />
                    )}
                {data.ClientRegularPayment && (
                    <RegularPaymentDetail
                        {...this.getProps(PaymentType.Client)}
                        readonly={
                            (clientNextPaymentdate != -1 &&
                                clientNextPaymentdate <= 10 &&
                                this.props.processType === processTypeEnum.RegularPayment) ||
                            this.props.autoLineCompleted === false
                        }
                        autoLineCompleted={this.props.autoLineCompleted}
                    />
                )}
                {thirdPartyNextPaymentdate != -1 &&
                    thirdPartyNextPaymentdate <= 10 &&
                    this.props.processType === processTypeEnum.RegularPayment && (
                        <Alert
                            alertType={AlertType.Warning}
                            message={`Please note the next collection date is within 10 days so cannot be edited.`}
                        />
                    )}
                {data.ThirdPartyRegularPayment && (
                    <RegularPaymentDetail
                        {...this.getProps(PaymentType.ThirdParty)}
                        readonly={
                            (thirdPartyNextPaymentdate != -1 &&
                                thirdPartyNextPaymentdate <= 10 &&
                                this.props.processType === processTypeEnum.RegularPayment) ||
                            this.props.autoLineCompleted === false
                        }
                        autoLineCompleted={this.props.autoLineCompleted}
                    />
                )}
                {employerSalaryDeductionNextPaymentdate != -1 &&
                    employerSalaryDeductionNextPaymentdate <= 10 &&
                    this.props.processType === processTypeEnum.RegularPayment && (
                        <Alert
                            alertType={AlertType.Warning}
                            message={`Please note the next collection date is within 10 days so cannot be edited.`}
                        />
                    )
                }
                {data.EmployerSalaryDeductionRegularPayment && (
                    <RegularPaymentDetail
                        {...this.getProps(PaymentType.EmployerSalaryDeduction)}
                        readonly={
                            (employerSalaryDeductionNextPaymentdate != -1 &&
                                employerSalaryDeductionNextPaymentdate <= 10 &&
                                this.props.processType === processTypeEnum.RegularPayment) ||
                            this.props.autoLineCompleted === false
                        }
                        autoLineCompleted={this.props.autoLineCompleted}
                    />
                )}
                {employerNextPaymentdate != -1 &&
                    employerNextPaymentdate <= 10 &&
                    this.props.processType === processTypeEnum.RegularPayment && (
                        <Alert
                            alertType={AlertType.Warning}
                            message={`Please note the next collection date is within 10 days so cannot be edited.`}
                        />
                    )}
                {data.EmployerRegularPayment && (
                    <RegularPaymentDetail
                        {...this.getProps(PaymentType.Employer)}
                        readonly={
                            (employerNextPaymentdate != -1 &&
                                employerNextPaymentdate <= 10 &&
                                this.props.processType === processTypeEnum.RegularPayment) ||
                            this.props.autoLineCompleted === false
                        }
                        autoLineCompleted={this.props.autoLineCompleted}
                    />
                )}
            </WizardLinter>
        );
    }
}
